// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3bCQv","requiredAsterisk":"Info_requiredAsterisk__3jZb1"};